/**
 * Invite links: /?ref=CODE. A code is 8 symbols with no look-alikes (no 0/O, 1/I/L), so it
 * survives being read aloud or typed from a screenshot; letters are taken in either case.
 */
export const REFERRAL_ALPHABET = "ABCDEFGHJKMNPQRSTUVWXYZ23456789";
export const REFERRAL_LENGTH = 8;

/** A code as stored (upper case), or null if it cannot be one. */
export function normalizeReferral(code: string): string | null {
  const c = code.trim().toUpperCase();
  if (c.length !== REFERRAL_LENGTH) return null;
  for (const ch of c) if (!REFERRAL_ALPHABET.includes(ch)) return null;
  return c;
}

/** A new code from random bytes (crypto on the api). */
export function referralCodeFrom(bytes: Uint8Array): string {
  let out = "";
  for (let i = 0; i < REFERRAL_LENGTH; i++)
    out += REFERRAL_ALPHABET[(bytes[i] ?? 0) % REFERRAL_ALPHABET.length];
  return out;
}

/** The character picture a share card shows: drawn by the game, checked by the api. */
export const SHARE_PORTRAIT = { width: 600, height: 800, maxBytes: 1_000_000 } as const;
